export default "__VITE_ASSET__7e6fa750__"